import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
//i18n
import MetaTags from "react-meta-tags";
//redux
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import { getChartsDataMessageStatus } from "store/actions";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DonutChart from "./dountchart";
import ListSaleInvoiceHaveCode from "./ListInvoice/ListSaleInvoiceHaveCode";
import WelcomeComp from "./WelcomeComp";
const Dashboard = props => {
  const [modal, setmodal] = useState(false);
  const { t, i18n } = useTranslation();
  const [subscribemodal, setSubscribemodal] = useState(false);
  const Dashboard = useSelector(state => state.Dashboard);
  const {
    loading,
    totalMessage,
    chartsMLTDiep,
    chartMLTDiepInYear,
    listTenant,
    listMessageWithStatus,
    tenantCodeHeader,
  } = Dashboard;
  const dispatch = useDispatch();
  const { chartsData } = useSelector(state => ({
    chartsData: state.Dashboard.chartsData,
  }));
  const [tenantCodeChart, setTenantCodeChart] = useState(null);
  const [periodType, setPeriodType] = useState("monthly");
  const onChangeChartPeriod = pType => {
    setPeriodType(pType);
    // dispatch(onGetChartsData(pType))
  };
  useEffect(() => {
    if (tenantCodeHeader) {
      setTenantCodeChart(tenantCodeHeader);
    }
  }, [tenantCodeHeader]);
  useEffect(() => {
    if (tenantCodeChart) {
      //TODO call api chart with tenant
      dispatch(
        getChartsDataMessageStatus(tenantCodeChart, new Date().getFullYear())
      );
    }
  }, [tenantCodeChart]);
  const stackedData = [
    {
      name: "New hire",
      data: [4, 2, 5, 4, 3, 6, 7, 1, 1, 6, 12, 2],
    },
    {
      name: "Renew",
      data: [3, 2, 2, 6, 9],
    },
    {
      name: "Transfer & change salary",
      data: [10, 2, 2, 6],
    },
    {
      name: "Transfer & no change salary",
      data: [20, 2, 2, 2],
    },
  ];
  const MESSAGE_STATUS = {
    invoice_cma: {
      title: "Tạo mới",
      color: "info",
      icon: "bx bxs-message-rounded-detail",
    },
    P: {
      title: "Đang xử lý",
      color: "primary",
      icon: "bx bxs-message-rounded-detail",
    },
    A: {
      title: "Hoàn thành",
      color: "success",
      icon: "bx bxs-message-rounded-detail",
    },
    R: {
      title: "Lỗi",
      color: "warning",
      icon: "bx bxs-message-rounded-detail",
    },
  };
  //   useEffect(() => {
  //     setTimeout(() => {
  //       setSubscribemodal(true);
  //     }, 2000);
  //   }, []);

  //   const [periodData, setPeriodData] = useState([]);
  //   const [periodType, setPeriodType] = useState("yearly");

  //   useEffect(() => {
  //     setPeriodData(chartsData);
  //   }, [chartsData]);

  //   const onChangeChartPeriod = pType => {
  //     setPeriodType(pType);
  //     dispatch(onGetChartsData(pType));
  //   };

  //   const dispatch = useDispatch();
  //   useEffect(() => {
  //     dispatch(onGetChartsData("yearly"));
  //   }, [dispatch]);
  const listDocumentData = {
    invoice_cma: {
      title: "HĐ GTGT có mã",
      value: "0",
      link: "/issue-vat-invoice/have-code",
      color: "info",
      icon: "bx bxs-receipt",
    },
    invoice_kma: {
      title: "HĐ GTGT không mã",
      value: "0",
      link: "/issue-vat-invoice/none-code",
      color: "info",
      icon: "bx bx-receipt",
    },
    invoice_sell_cm: {
      title: "HĐ BH có mã",
      value: "0",
      link: "/issue-sales-invoice/have-code",
      color: "primary",
      icon: "bx bxs-receipt",
    },
    invoice_sell_km: {
      title: "HĐ BH không mã",
      value: "0",
      link: "/issue-sales-invoice/none-code",
      color: "primary",
      icon: "bx bx-receipt",
    },
    invoice_ticket_cm: {
      title: "Tem,vé (HĐ GTGT) có mã",
      value: "0",
      link: "/issue-invoice-tickets/have-code",
      color: "success",
      icon: "bx bxs-receipt",
    },
    invoice_ticket_km: {
      title: "Tem,vé (HĐ GTGT) không mã",
      value: "0",
      link: "/issue-invoice-tickets/none-code",
      color: "success",
      icon: "bx bx-receipt",
    },
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>4Si E-Invoice</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbItem={"Bảng hiển thị"} />
          <Row>
            <Col xl="3">
              <WelcomeComp
                style={{ height: "93%" }}
                totalMessage={totalMessage}
                tenant={tenantCodeChart}
              />
              <Card>
                <CardBody>
                  <CardTitle className="mb-4 text-primary">
                    Thống kê theo loại hóa đơn phát hành
                  </CardTitle>
                  {loading ? (
                    <div className="spinner-chase mb-2 ">
                      <div className="chase-dot" />
                      <div className="chase-dot" />
                      <div className="chase-dot" />
                      <div className="chase-dot" />
                      <div className="chase-dot" />
                      <div className="chase-dot" />
                    </div>
                  ) : (
                    <DonutChart
                      series={chartsMLTDiep && chartsMLTDiep.data.series}
                      labels={chartsMLTDiep && chartsMLTDiep.data.labels}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col xl="9">
              <ListSaleInvoiceHaveCode></ListSaleInvoiceHaveCode>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default Dashboard;
